import {AxiosServer, AxiosEsb,ArrRemoveSubItem} from '../../utils';
import {message} from 'antd';

let namespace = 'purorderpending_';

//直接dispatch 为同步方法，比如  dispatch({type:'login/set',payload:{loading:false}});
//store 使用了thunk中间件，以下方法均为异步加载。

const purorderPendingAc = {
	SET:(value) =>(dispatch,getState)=>{
		dispatch({type: namespace+'forcedUpdate', payload: value})},		

	GET:(value)=>(dispatch,getState)=>{
		
		let store =getState().purOrderPendingRd;
		let {dataFetchProps,pagination} =store;
		let {current:currentPage,pageSize} =pagination;
		dataFetchProps ={...dataFetchProps,...value,currentPage,pageSize}		
		let Axios = AxiosServer();
		return Axios.post('/purOrder/findAll',dataFetchProps).then((res)=>{	
							
			if (res.data.status == true){				
				pagination ={...pagination,total:res.data.count}
				dispatch({type: namespace+'forcedUpdate', payload: {data:res.data.data, pagination:pagination,dataLoading: false}}); // 翻页的时候，先更新 dataLoading: true
				return '刷新成功'
			}else{
				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}}); 
				return '刷新失败'
			}
			
		}).catch((err)=>{
			message.error('orderList ' + err,10);
			dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}}); 
			return '错误'
	})
	},


	GETENGINEERINGNAME:(value)=>(dispatch,getState)=>{

		let Axios = AxiosServer();
		return Axios.post('/purRecordOrder/findEngineeringName',value).then((res)=>{
			if (res.data.status == true){
				dispatch({type: namespace+'forcedUpdate', payload: {engineeringData:res.data.data,dataLoading: false}}); // 翻页的时候，先更新 dataLoading: true
				return '刷新成功'
			}else{
				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}});
				return '刷新失败'
			}

		}).catch((err)=>{
			dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}});
			return '错误'
		})
	},
	// 将上传的文件保存到purOrderFile表。
	TOFILE:(value)=>(dispatch,getState)=>{			
		let Axios = AxiosServer();
		return  Axios.post('/purOrderFile/create',value).then((res)=>{		
		   
			//更新成功，重新获取数据			
			dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}}); 		   
			return '上传成功';
		}).catch((err)=>{
			//dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:',err);
			return 'error'
		})
	},
	// 将上传的文件更新到purOrderFile表。
	UPDATEFILE:(value)=>(dispatch,getState)=>{
		let Axios = AxiosServer();
		return  Axios.post('/purOrderFile/update',value).then((res)=>{

			//更新成功，重新获取数据
			dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}});
			return '上传成功';
		}).catch((err)=>{
			//dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:',err);
			return 'error'
		})
	},


	UPDATE:(value, selectedRowIndex = null)=>(dispatch,getState)=>{
		//可以多次dispatch(), value 是传过来的参数,  getState() 可获取当前store的状态	
		//dispatch({type:'login/set',payload:{loading:true}});
		//value 是传过来的参数
		//getState 可获取当前store的状态
		//强转id为数字，规免出错
		let id = parseInt(value.id);			
		
		let Axios = AxiosServer();
		return  Axios.post('/purOrder/update',value).then((res)=>{	
		
			if (res.data.status){
				//更新成功，重新获取数据			
				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}}); 
				return '更新成功'
			}
			return '更新失败'
			
		}).catch((err)=>{
			//dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:',err);
			return 'error'
		})
	},	
	
	UPDATEREMOVE:(value,selectedRowIndex)=> (dispatch,getState)=>{	
		
		let id = parseInt(value.id);			
		let Axios = AxiosServer();			
		return  Axios.post('/purOrder/update',value).then((res)=>{		
			
			dispatch({type:namespace+'updateDataById', payload: {id: value.id, data: res.data.data, selectedRowIndex}});
			dispatch({type:namespace+'RemoveDataByIndex', payload: {selectedRowIndex}});				
		
		   return '更新成功'
		}).catch((err)=>{
			dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:',err);
			return 'error'
		})
		
	
	},
	
	ESBTOSFTP:(id)=> (dispatch,getState)=>{	
	
		let Axios = AxiosEsb();
		
		return  Axios.post('/api/towxsbank/pur/sendToSftp',{id:id}).then((res)=>{		
			
			//更新成功，重新获取数据			
			dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}}); 
		   return '更新成功'
		}).catch((err)=>{			
			console.log('err:',err);
			return 'error'
		})
	
	},
	ESBTOSUPPLY:(value)=> (dispatch,getState)=>{

		let Axios = AxiosEsb();

		return  Axios.post('/api/towxsbank/supplyMaterailOtcg',{id:value.id}).then((res)=>{

			//提交成功，更新数据

			if (res.data.status){

				//更新后台为同意

				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}});
				return res.data.msg
			}

			return '补件失败'


		}).catch((err)=>{
			console.log('err:',err);
			return 'error'
		})

	},
	
	ESBTOSUBMIT:(value)=> (dispatch,getState)=>{			

		let Axios = AxiosEsb();			
		
		return  Axios.post('/api/towxsbank/submitOrderOtcg',{id:value.id,engineering_id:value.engineering_id}).then((res)=>{
			
			//提交成功，更新数据
			
			if (res.data.status){
				
				//更新后台为同意				
				dispatch(purorderPendingAc.UPDATE(value));
				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}}); 
				return res.data.msg
			}
			
			return '更新失败'
			
		   
		}).catch((err)=>{			
			console.log('err:',err);
			return 'error'
		})
	
	},
	DELETEFILE:(value)=>(dispatch,getState)=>{
		let Axios = AxiosServer();
		return  Axios.post('/purOrderFile/destroy',{id:value}).then((res)=>{

			//更新成功，重新获取数据
			dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: true}});
			return '上传成功';
		}).catch((err)=>{
			//dispatch({type:'login/set',payload:{loading:false}});
			console.log('err:',err);
			return 'error'
		})
	},
	

}


export {purorderPendingAc};